import { render } from "./Modern.vue?vue&type=template&id=5974b0d9"
import script from "./Modern.vue?vue&type=script&lang=js"
export * from "./Modern.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__